/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AccountSettings_viewer = {|
  +isFacebookEnabled: ?boolean;
  +socialNetworks: ?$ReadOnlyArray<?{|
    +serviceId: ?string;
    +name: ?string;
    +parameters: ?{|
      +clientId: ?string;
    |};
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSettings_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isFacebookEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "facebookConnection",
          "type": "String!"
        }
      ],
      "name": "isEnabled",
      "storageKey": "isEnabled{\"key\":\"facebookConnection\"}"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SocialNetwork",
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "serviceId",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "SocialNetworkParameters",
          "name": "parameters",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "clientId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialNetworks/__generated__/AccountSettings_viewer.graphql.js